import { render, staticRenderFns } from "./JudgingBtns.vue?vue&type=template&id=785b1d19&"
import script from "./JudgingBtns.vue?vue&type=script&lang=js&"
export * from "./JudgingBtns.vue?vue&type=script&lang=js&"
import style0 from "./JudgingBtns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports